module.exports = __webpack_public_path__ + "img/visual_design_summary.aed47a9e.jpg";